import { Component, OnInit } from '@angular/core';
import { createStore } from "devextreme-aspnet-data-nojquery";
import { BaseService } from 'src/app/services/base.service';
import notify from 'devextreme/ui/notify';
import { FcPivotModel } from 'src/app/models/forecast/fc-pivot-model';
import { FcvalidationlogService } from '../fcvalidationlog.service';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-pivotv2',
    templateUrl: './pivotv2.component.html',
    styleUrls: ['./pivotv2.component.scss'],
    standalone: false
})
export class Pivotv2Component implements OnInit {

    FcParamCaption: any = [];
    applyChangesMode: any;
    layout = "Layout0";

    constructor(private baseService: BaseService, private FcLogSvc: FcvalidationlogService,
        private titleService: Title) {

        this.applyChangesMode = "onDemand";
        this.layout = "Layout0";
        this.titleService.setTitle("Pivot");

        this.FcLogSvc.GetForecastPivotColumnV2().subscribe(resp => {
            if (resp) {
                resp[0].forEach(
                    element => {
                        this.FcParamCaption.push({
                            'area': element.Area, 'areaIndex': element.AreaIndex, 'dataField': element.FieldName,
                            'expanded': element.Expanded, 'filterType': element.FilterType, 'filterValues': element.FilterValues,
                            'name': element.Name, 'sortBy': element.SortBy, 'sortBySummaryField': element.sortBySummaryField,
                            'sortBySummaryPath': element.SortBySummaryPath, 'sortOrder': element.SortOrder,
                            'summaryDisplayMode': element.SummaryDisplayMode, 'summaryType': element.SummaryType, 'dataType': '',
                            'caption': element.FieldCaption, 'width': '30'
                        });
                    }
                );

                resp[1].forEach(element => {
                    if (element.FieldName == "Period") {
                        this.FcParamCaption.push({
                            'area': element.Area, 'areaIndex': element.AreaIndex, 'dataField': element.FieldName,
                            'expanded': element.Expanded, 'filterType': element.FilterType, 'filterValues': element.FilterValues,
                            'name': element.Name, 'sortBy': element.SortBy, 'sortBySummaryField': element.sortBySummaryField,
                            'sortBySummaryPath': element.SortBySummaryPath, 'sortOrder': element.SortOrder,
                            'summaryDisplayMode': element.SummaryDisplayMode, 'summaryType': element.SummaryType,
                            'caption': element.FieldCaption, 'dataType': 'number'
                        });
                    }
                    else {
                        this.FcParamCaption.push({
                            'area': element.Area, 'areaIndex': element.AreaIndex, 'dataField': element.FieldName,
                            'expanded': element.Expanded, 'filterType': element.FilterType, 'filterValues': element.FilterValues,
                            'name': element.Name, 'sortBy': element.SortBy, 'sortBySummaryField': element.sortBySummaryField,
                            'sortBySummaryPath': element.SortBySummaryPath, 'sortOrder': element.SortOrder,
                            'summaryDisplayMode': element.SummaryDisplayMode, 'summaryType': element.SummaryType,
                            'caption': element.FieldCaption, 'dataType': 'number', 'format': '#,##0.##'
                        });
                    }
                });
                this.FcParamCaption.push({ 'caption': 'Period', 'dataField': 'Period', 'area': 'column' });

                let auto = this.baseService.getNewOptions();

                this.pivotGridDataSource = new PivotGridDataSource({
                    remoteOperations: true,
                    store: createStore({
                        key: "forecastObjectClientId",
                        loadUrl: this.baseService.getCorrectUrl("forecast/GetForecastPivotV2"),
                        onBeforeSend: (operation, ajaxOptions) => {
                            ajaxOptions.headers = auto['headers']
                        }
                    }),
                    fields: this.FcParamCaption
                });

                this.pivotGridDataFeildChooserSource = new PivotGridDataSource({
                    fields: this.FcParamCaption
                });

                this.state = this.pivotGridDataSource.state();
                this.customizeTooltip = this.customizeTooltip.bind(this);
            }
        });
    }

    ngOnInit() {
    }

    showDataFields: boolean = true;
    showRowFields: boolean = true;
    showColumnFields: boolean = true;
    showFilterFields: boolean = true;

    pivotGridDataSource: any;
    pivotGridDataFeildChooserSource: any;

    showfieldchooserPopUp: boolean = false;
    state: any;
    withAnimationVisible = false;
    pivotsetting: FcPivotModel;

    contextMenuPreparing(e) {
        let dataSource = e.component.getDataSource(),
            sourceField = e.field;

        if (sourceField) {
            if (!sourceField.groupName || sourceField.groupIndex === 0) {
                e.items.push({
                    text: "Hide field",
                    onItemClick: function () {
                        let fieldIndex;
                        if (sourceField.groupName) {
                            fieldIndex = dataSource.getAreaFields(sourceField.area, true)[sourceField.areaIndex].index;
                        } else {
                            fieldIndex = sourceField.index;
                        }
                        dataSource.field(fieldIndex, {
                            area: null
                        });
                        dataSource.load();
                    }
                });
            }

            if (sourceField.dataType === "number") {
                let setSummaryType = function (args) {
                    dataSource.field(sourceField.index, {
                        summaryType: args.itemData.value
                    });
                    dataSource.load();
                },
                    menuItems = [];

                e.items.push({ text: "Summary Type", items: menuItems });

                for (let summaryType of ["Sum", "Avg", "Min", "Max"]) {
                    let summaryTypeValue = summaryType.toLowerCase();
                    menuItems.push({
                        text: summaryType,
                        value: summaryType.toLowerCase(),
                        onItemClick: setSummaryType,
                        selected: e.field.summaryType === summaryTypeValue
                    });
                };
            }
        }
    }


    applyChanges() {
        console.log(this.state,'state');

        this.pivotGridDataSource.state(this.state);
        this.showfieldchooserPopUp = false;
    }

    cancelChanges() {
        this.state = this.pivotGridDataSource.state();
        this.showfieldchooserPopUp = false;
    }

    showfieldchooser() {
        this.showfieldchooserPopUp = true;
    }

    toggleWithAnimation() {
        this.withAnimationVisible = !this.withAnimationVisible;
    }
    customizeTooltip(args) {
        return {
            html: args.seriesName + " | Total<div class='currency'>" + args.valueText + "</div>"
        };
    }
    savesettings() {

        this.pivotsetting = this.state.fields;
        this.FcLogSvc.savePivotUserSettings(this.pivotsetting, '1').subscribe(resp => {
            if (resp) {
                notify(resp.response, "success", 3000);

            }
        });
    }

    loadDynamicWidth(width:number) {return $(window).width() * width }
}
